import { getIn, useFormikContext } from "formik"
import { useEffect, useMemo, useState, useTransition } from "react";

import clsx from 'clsx';
import { useDebounce } from "../../../../../_metronic/helpers";
import { createDLMDOC, DOC_MODEL_CHECK_FIELDS } from "../../../core/doclabel";

import { getErrorMessage, isPopulatedArray, isValidString } from "../../../../components/helpers";

type Props = {
  appID: number,  
}

export const DLMCreateDOCButton = ({appID} : Props) => {


  const [goText, setGoText] = useState<string>('');        
  const debouncedGoText = useDebounce(goText, 800);

  const [ isLoading, LoadValues] = useTransition();

  const { values, setFieldValue } = useFormikContext() ;

  const hasDOCModels = useMemo(() => {
    if (! values) return false;
    const docModels = getIn(values, 'docModels');
    if (! isPopulatedArray(docModels)) {
      return false;
    }

    let hasMissing = false;
    docModels.forEach( (doc: any) => {
      DOC_MODEL_CHECK_FIELDS.forEach( fld => {
        if (! isValidString(doc[fld])) {
          hasMissing = true;          
        }
      })      
    });
    
    return (! hasMissing);
  }, [values]);

  const createDOCModels =  () =>  {    
    
    if (isLoading || (! appID) || hasDOCModels) {        
      return;
    }
    LoadValues( () => {            
      createDLMDOC(appID)
      .then( res => {
        if (! res.data && res.data.length > 0) {
          console.error('Something happened');
        }
        setFieldValue('docModels', res.data);          
      })
      .catch( err => {
          console.error(getErrorMessage(err));
      })
      .finally(() => {
        setGoText('');
      })
    })
  };


  useEffect(() => {    
    if (debouncedGoText !== 'GO') return;      
    // run only once
    createDOCModels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedGoText])
  
  return (
    <div>
      { (! hasDOCModels) &&
      <span className="text-muted fs-7 me-2">Click to create DOC →</span>     
      }
      <button
        type="button"
        className={clsx('btn btn-sm btn-primary py-1 mb-1 px-3',
        { 'btn-primary': ! hasDOCModels},
        { 'btn-secondary': hasDOCModels},
        )}
        onClick={() => setGoText('GO')}
        disabled={isLoading}
      >
        <span className='indicator-label'>Create DOC</span>        
      </button>
    </div>  

  )


}